/**
 * Code that represents a human language, that consists in a underscore-separated
 * list of:
 * 1. language code, in {@link https://en.wikipedia.org/wiki/ISO_639-1 ISO 639-1}
 * 2. country code, in {@link https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2 ISO 3166-1 alpha 2} - or script code, in {@link https://en.wikipedia.org/wiki/ISO_15924 ISO 15924}
 *
 * @example 'en_US'
 * @example 'zh_HANS'
 *
 * @see {@link https://devportal.backmarket.io/docs/default/component/api-guidelines/rules/data_types/55/ MUST use language code format}
 * @see {@link https://devportal.backmarket.io/docs/default/component/api-guidelines/rules/data_types/56/ MUST use country code format}
 */
export const LOCALES = {
  de_AT: 'de_AT',
  de_DE: 'de_DE',
  el_GR: 'el_GR',
  en_GB: 'en_GB',
  en_AU: 'en_AU',
  en_IE: 'en_IE',
  en_US: 'en_US',
  es_ES: 'es_ES',
  es_US: 'es_US',
  fi_FI: 'fi_FI',
  fr_BE: 'fr_BE',
  fr_FR: 'fr_FR',
  it_IT: 'it_IT',
  ja_JP: 'ja_JP',
  nl_NL: 'nl_NL',
  pt_PT: 'pt_PT',
  sv_SE: 'sv_SE',
  sk_SK: 'sk_SK',
  zh_HANS: 'zh_HANS',
} as const

export type Locale = (typeof LOCALES)[keyof typeof LOCALES]

/**
 * Code that represents a human language, that consists in a hyphen-separated
 * list of:
 * 1. language code, in {@link https://en.wikipedia.org/wiki/ISO_639-1 ISO 639-1}
 * 2. country code, in {@link https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2 ISO 3166-1 alpha 2} - or script code, in {@link https://en.wikipedia.org/wiki/ISO_15924 ISO 15924}
 *
 * @example 'en-us'
 * @example 'zh-hans'
 *
 * @see {@link https://devportal.backmarket.io/docs/default/component/api-guidelines/rules/data_types/55/ MUST use language code format}
 * @see {@link https://devportal.backmarket.io/docs/default/component/api-guidelines/rules/data_types/56/ MUST use country code format}
 */
export const BCP_47_LOCALES = {
  de_AT: 'de-at',
  de_DE: 'de-de',
  el_GR: 'el-gr',
  en_GB: 'en-gb',
  en_AU: 'en-au',
  en_IE: 'en-ie',
  en_US: 'en-us',
  es_ES: 'es-es',
  es_US: 'es-us',
  fi_FI: 'fi-fi',
  fr_BE: 'fr-be',
  fr_FR: 'fr-fr',
  it_IT: 'it-it',
  ja_JP: 'ja-jp',
  nl_NL: 'nl-nl',
  pt_PT: 'pt-pt',
  sv_SE: 'sv-se',
  sk_SK: 'sk-sk',
  zh_HANS: 'zh-hans',
} as const

export type Bcp47Locale = (typeof BCP_47_LOCALES)[keyof typeof BCP_47_LOCALES]
